import { Injectable } from '@angular/core';
import { DtoParserType } from 'ngx-mat-esign360/lib/core/model/dto-parser-type.model';
import { EnvConfigService } from 'ngx-mat-esign360/lib/core/services/env-config.service';
import { CsasDtoParserService } from './csas-dto-parser.service';
import { DefaultDtoParserService } from './default-dto-parser.service';
import { DtoParserService } from './dto-parser.service';

@Injectable()
export class DtoParserWrapperService extends DtoParserService {
  dtoParser: DtoParserService;

  constructor(private envConfig: EnvConfigService) {
    super();
  }

  init() {
    switch (this.envConfig.data.dtoParserType) {
      case DtoParserType.Default:
        this.dtoParser = new DefaultDtoParserService();
        break;
      case DtoParserType.Csas:
        this.dtoParser = new CsasDtoParserService();
        break;
      default:
        this.dtoParser = new DefaultDtoParserService();
    }
  }

  parseTransaction(dtoTransaction: any) {
    return this.dtoParser.parseTransaction(dtoTransaction);
  }
}
